import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getEventsStrikePackages = async (user, handles) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
    const params = {
        handles
    };

    const config = {
        method: 'get',
        url: `/service/events_service/v1/no_auth/customer/event/packages`,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            user,
        },
        params,
    };
    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        console.error("Error fetching event details:", error);
        throw error;
    }
};


export default getEventsStrikePackages;